import { appConfig } from "../lib/config";
import { coachingServices } from "./coaching-services";
import { mockCoachingServices, mockCoachingApi } from "./coaching-mock-services";
import { createCoachingZ6Services, coachingZ6Services, type CoachingZ6Services } from "./coaching-z6-services";
import {
  createCoachingReadinessServices,
  coachingReadinessServices,
  type CoachingReadinessServices
} from "./coaching-readiness-services";

export type CoachingDataMode = "mock" | "live";
export type CoachingServices = typeof coachingServices;

const mockCoachingZ6Services = createCoachingZ6Services(mockCoachingApi);
const mockCoachingReadinessServices = createCoachingReadinessServices(mockCoachingApi);

export function getCoachingDataMode(): CoachingDataMode {
  return appConfig.dataMode === "live" ? "live" : "mock";
}

export function getCoachingServices(): CoachingServices {
  return getCoachingDataMode() === "live" ? coachingServices : mockCoachingServices;
}

/**
 * Z6 service family resolver. Live mode hits the coaching product API; mock mode
 * routes through the same in-memory requester the e2e/contract fixtures use, so
 * the Z6 surfaces degrade to honest empty/closed states without network traffic.
 */
export function getCoachingZ6Services(): CoachingZ6Services {
  return getCoachingDataMode() === "live" ? coachingZ6Services : mockCoachingZ6Services;
}

/**
 * Readiness service family resolver (settings / capstone-read / certificate /
 * report-generate). Live mode hits the coaching product API; mock mode routes
 * through the same in-memory requester the e2e/contract fixtures use, so these
 * surfaces degrade to honest empty/closed states without network traffic.
 */
export function getCoachingReadinessServices(): CoachingReadinessServices {
  return getCoachingDataMode() === "live" ? coachingReadinessServices : mockCoachingReadinessServices;
}
